"use client";

import { useState } from "react";

export interface FaqItemData {
  question: string;
  answerHtml: string;
}

interface FaqAccordionProps {
  title?: string;
  items: FaqItemData[];
}

export function FaqAccordion({ title = "Perguntas Frequentes (FAQ)", items }: FaqAccordionProps) {
  const [openIndexes, setOpenIndexes] = useState<Record<number, boolean>>({ 0: true });

  const toggleIndex = (idx: number) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  if (items.length === 0) return null;

  return (
    <div className="faq-accordion-section">
      <h2 style={{ marginTop: 48, marginBottom: 20 }}>{title}</h2>
      <div className="faq-accordion-container">
        {items.map((item, idx) => {
          const isOpen = Boolean(openIndexes[idx]);
          return (
            <div key={idx} className={`faq-item ${isOpen ? "faq-item--open" : ""}`}>
              <button
                type="button"
                className="faq-summary"
                onClick={() => toggleIndex(idx)}
                aria-expanded={isOpen}
              >
                <span>{item.question}</span>
                <span className="faq-icon-badge">{isOpen ? "▴" : "▾"}</span>
              </button>

              {isOpen && (
                <div
                  className="faq-body"
                  dangerouslySetInnerHTML={{ __html: item.answerHtml }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
